import { Component, OnInit, OnDestroy, Input, ElementRef, Renderer2 } from '@angular/core';
import { AlertService } from '../core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'alert',
  templateUrl: './alert.component.html'
})

export class AlertComponent implements OnInit, OnDestroy {
  @Input() id: string;

  constructor(
    protected alert: AlertService,
    protected htmlComponent: ElementRef,
    protected domModifier: Renderer2
  ) { }

  ngOnInit(): void {
    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    this.alert.addModalDialog(this);

    switch (this.id) {
      case 'splashscreen':
        break;
      case 'commonalert':
        this.close();
        break;
    }
  }

  ngOnDestroy(): void {
    this.alert.removeModalDialog(this.id);
  }

  // open modal
  open(): void {
    this.domModifier.setStyle(this.htmlComponent.nativeElement, 'display', 'block');
  }
  // close modal
  close(): void {
    this.domModifier.setStyle(this.htmlComponent.nativeElement, 'display', 'none');
  }

  // open alert modal adding test
  openMessage(text: string, targetid: string, titlealert?: string): void {
    // Change alert title
    if (this.htmlComponent.nativeElement.querySelector(`#pTitle`) && titlealert) {
      this.htmlComponent.nativeElement.querySelector(`#pTitle`).innerText = !titlealert ? 'alert' : titlealert;
    }

    if (this.htmlComponent.nativeElement.querySelector(`#${targetid}`)) {
      this.htmlComponent.nativeElement.querySelector(`#${targetid}`).innerText = text;
    }
    this.domModifier.setStyle(this.htmlComponent.nativeElement, 'display', 'block');
  }

}
